import React from "react";
import { colors } from "@/assets/themes";
import { Body14 } from "../../text";
import type { SubtitleProps } from "../types";

const Subtitle = ({ children, ...rest }: SubtitleProps) => (
  <Body14 color={colors.muted} {...rest}>
    {children}
  </Body14>
);

export default Subtitle;
